import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { FeaturePitchOverlayComponent } from "@m19-board/overlay/feature-pitch-overlay/feature-pitch-overlay.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";
import { ProductTourCtaComponent } from "@m19-board/overlay/product-tour-cta/product-tour-cta.component";

@Component({
  selector: "app-amc-product-tour-overlay",
  imports: [TranslocoDirective, FeaturePitchOverlayComponent, ProductTourCtaComponent],
  template: `
    <app-feature-pitch-overlay *transloco="let t" feature="amc" [title]="t('product-tour.locked_amc_title')">
      <app-product-tour-cta />
    </app-feature-pitch-overlay>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmcProductTourOverlayComponent {
  static readonly rule = OverlayRule.PRODUCT_TOUR;
}
